export default "__VITE_ASSET__D3QXDEoR__"